module.exports = __webpack_public_path__ + "img/edit.ac9eeeb5.svg";